import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::index
* @see app/Http/Controllers/Teacher/TieredPricingController.php:24
* @route '/teacher/plans'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/plans',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::index
* @see app/Http/Controllers/Teacher/TieredPricingController.php:24
* @route '/teacher/plans'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::index
* @see app/Http/Controllers/Teacher/TieredPricingController.php:24
* @route '/teacher/plans'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::index
* @see app/Http/Controllers/Teacher/TieredPricingController.php:24
* @route '/teacher/plans'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::update
* @see app/Http/Controllers/Teacher/TieredPricingController.php:41
* @route '/teacher/plans/{tier}'
*/
export const update = (args: { tier: string | number } | [tier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/plans/{tier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::update
* @see app/Http/Controllers/Teacher/TieredPricingController.php:41
* @route '/teacher/plans/{tier}'
*/
update.url = (args: { tier: string | number } | [tier: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tier: args }
    }

    if (Array.isArray(args)) {
        args = {
            tier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tier: args.tier,
    }

    return update.definition.url
            .replace('{tier}', parsedArgs.tier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TieredPricingController::update
* @see app/Http/Controllers/Teacher/TieredPricingController.php:41
* @route '/teacher/plans/{tier}'
*/
update.put = (args: { tier: string | number } | [tier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const plans = {
    index: Object.assign(index, index),
    update: Object.assign(update, update),
}

export default plans